const REGEX = {
  CHECK_DOMAIN: /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/,
  CHECK_SUBDOMAIN: /^[a-z0-9][a-z0-9-]*[a-z0-9]$/,
};

export default REGEX;
